import React, { useEffect } from 'react';
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';
import { getPortalId, getFormId } from '../../config/hubspotConfig';

const AcceptanceForm = ({ fetchHubspotFormStatus, currentApplicant, courseApplicationData }) => {
  useEffect(() => {
    document.title = "Accept Admission Offer | LaunchCode";
  }, []);

  const { loaded, error, formCreated } = useHubspotForm({
    portalId: getPortalId(),
    formId: getFormId('acceptance'),
    target: '#course-application',
    onFormReady: function($form){
      var $theEmail = $form.find('input[name="email"]');
      $theEmail.val(currentApplicant.email).change();
    },
    onFormSubmitted: function($form) {
      fetchHubspotFormStatus('admission_offered');
    }
  });

  return (
    <>
      <h2>Accept Admission Offer</h2>
      <div id='course-application'></div>
    </>
  )
};

export default AcceptanceForm;
